module.exports = __webpack_public_path__ + "static/media/nynfc1.b181cbb3.jpg";